import React, { Component } from 'react';
import Add from '../images/add.png'
import Edit from '../images/edit.png'
import Delete from '../images/delete.png'
import lock from "../images/lock.png"
import Direction from "../images/direction.png"
import { FaCheck } from "react-icons/fa";
import { Editor } from "react-draft-wysiwyg";
import { editorState, convertToRaw, ContentState, convertFromHTML, Modifier, EditorState } from 'draft-js';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import Parser from 'html-react-parser';
import $ from 'jquery'
import { apiCallingPost } from "../service";
const toolbarTools = {
  options: ['inline', 'link', 'list'],
  inline: {
    options: []
  },
  link: {
    options: []
  },
  list: {
    options: ['unordered']
  }
}
let roleName;
let contentHeading, contentDataSubId
class LocalPageServices extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isAboutChange: '0',
      isApprovedEnable: 0,
      ["editorState"]: '',
      ["editorState2"]: '',
      passingType: false,
      servicesDetails: this.props.servicesDetails.length > 0 ? this.props.servicesDetails : []
    }
  }
  //  / const [servicesDetails, setServicesDetails] = useState(this.props.servicesDetails.length > 0 ? JSON.parse(this.props.servicesDetails[0].contentDataSubDescription) : [])

  componentDidMount() {
    roleName = window.sessionStorage.getItem('roleName')
    this.setState({ isApprovedEnable: this.props.servicesDetails.filter(sectionObject => sectionObject.contentDataSubIsApproved === "0").length })
  }
  componentWillReceiveProps(nextProps) { 
    roleName = window.sessionStorage.getItem('roleName')
    this.setState({ isApprovedEnable: nextProps.servicesDetails.filter(sectionObject => sectionObject.contentDataSubIsApproved === "0").length })
}

  onEditorStateChange = (e, mode) => {
    this.setState({
      [mode]: e
    });
    // console.log("onEditorStateChange", e);
  };
  handleBeforeInput = (e, mode) => {
    // console.log("handleBeforeInput=", e);
    const currentContent = this.state[mode].getCurrentContent();
    const currentContentLength = currentContent.getPlainText('').length
    // if (currentContentLength > 500) {
    //   return 'handled';
    // }
  };
  saveServiceDetails = (mode, index) => {

    var flag = true;
    if (this.state.passingType === false) {
      if ($("#serviceHeading").val() === "") {
        alert("Enter Title")
        $("#serviceHeading").focus()
        flag = false
      }
    }

    if (flag === true) {
      //debugger
      let contentDataId = this.props.servicesDetailsContentDataId;
       let contentDataSubId = this.props.servicesDetailsContentDataSubId
      // let isApproved = this.this.props.firstview.contentDataSubIsApproved
      let isApproved = this.props.servicesDetails.length > 0 ? this.props.servicesDetails[0].contentDataSubIsApproved : "0"
      let isSaveDraft = mode === "DRAFT" ? "true" : "false";
      let SubDescription = "";

      if (this.state.passingType === false) {
        if (this.state["editorState"] !== '') {
          SubDescription = draftToHtml(convertToRaw(this.state["editorState"].getCurrentContent()))
        }
        contentHeading = $("#serviceHeading").val();
        contentDataSubId = ""
      }
      else {
        if (this.state["editorState2"+index] !== '') {
          SubDescription = draftToHtml(convertToRaw(this.state["editorState2"+index].getCurrentContent()))
        }
        contentHeading = $("#serviceHeading" + index).val();
      }
      const postData = {
        functionName: "saveContentDataSub",
        contentDataId: contentDataId,
        contentDataSubId: contentDataSubId,
        contentDataSubDescription: SubDescription,
        contentDataSubTitle: contentHeading,
        siteId: "",
        contentDataSubIsApproved: isApproved,
        image: "",
        userRole: window.sessionStorage.getItem("roleName"),
        oldImage: "",
        isSaveDraft: isSaveDraft,
        contentDataSubSortOrder: "",
        contentDataSubSubtitle: "",
        pageId: "1",
        altText: "",
        h3Tag: "",
      };
      // console.log("postData---save----", postData);
      apiCallingPost(postData).then((data) => {
        if (data.data.success == 1) {
          alert("Saved Successfully");
          this.cancelLocationOption();
          this.props.getData();
        }
      });
    }
  }

  addServicesDetails = () => {
    $(".locator_option").addClass("editActive");
    this.setState({
      isAboutChange: "1",
      ["editorState"]: ''
    })
  }
  editServicesDetails = (object, index) => {
    // console.log("object=", object);
    // console.log("index=", index);
    $("#servicesDetails" + index).addClass("editActive");
    this.setState({
      isAboutChange: "1",
      ["editorState2"+index]: ''
    })
    this.setState({ passingType: true })
    $("#serviceHeading" + index).val(this.props.servicesDetails[index].contentDataSubTitle)
    this.setState({
      ["editorState2"+index]: EditorState.createWithContent(
        ContentState.createFromBlockArray(
          convertFromHTML(this.props.servicesDetails[index].contentDataSubDescription)
        )
      )
    })
    contentDataSubId = object.contentDataSubId
    //console.log("contentHeading=", contentHeading);
  }
  deleteServicesDetails = (object, index) => {
    const postData = {
      functionName: "delete",
      contentDataSubId: object.contentDataSubId
    }
    if (window.confirm("Do you want to delete?")) {
      apiCallingPost(postData).then((data) => {
        //console.log('delete  ', data) 
        if (data.data.success == 1) {
          this.props.getData()
        }
      });
    } else {
      return false;
    }
  }
  cancelLocationOption = () => {
    $(".locator_option, .services_details_position").removeClass("editActive");
    this.setState({ passingType: false })
  }
  rejectData = (contentDataSubId, index) => {
    this.props.rejectData(contentDataSubId, $("#servicesRejectReason" + index).val())
  }
  approveClick = () => {
    if (this.state.isApprovedEnable > 5) {
      alert("Sorry! You can approve maximum 5 Events")
    }
    else {
      this.props.approveClick(this.props.servicesDetailsContentDataId)
      // setTimeout(() => {
      //   window.location.reload();
      // }, 500);
    }
  }
  render() {
    return (
      <div className="col-md-12 service_locator_option">
      <div className="adminIconLeft">
      {window.sessionStorage.getItem('roleName') === "SuperAdmin" && this.state.isApprovedEnable > 0 ?
      <div className="">
        <div className="approveButton" onClick={() => this.approveClick()}>Approve</div>
      </div>
      : ""}
      </div>
        {/* <div className="adminIconLeft">
          {window.sessionStorage.getItem('roleName') === "SuperAdmin" && this.state.isApprovedEnable > 0 ?
            <div className="">
              <div className="approveButton" onClick={() => this.approveClick()}>Approve</div>
            </div>
            : ""}
            </div> */}
          {this.props.servicesDetails.length > 0 ?
            this.props.servicesDetails.map((object, index) => (
              <div id={"servicesDetails" + index} key={index} className={"service_positions"}>
                <div className="service_options">
                  <h2 className="service_optionhead">
                    {object.contentDataSubTitle}
                  </h2>
                  {Parser(object.contentDataSubDescription)}
                  {(window.sessionStorage.getItem('isLogedIn') === "1" ?
                    this.props.servicesDetails.length > 0 &&
                    (window.sessionStorage.getItem("roleName") === "SuperAdmin" ||
                      window.sessionStorage.getItem("roleName") === "Admin") && (
                      <>
                        <div className="adminIconMain">
                          {((object.contentDataSubIsApproved === '1' || object.isSaveDraft === "true")) &&
                            <span
                              className="editIcon editButton"
                              onClick={(e) => {
                                this.editServicesDetails(object, index);
                              }}
                            >
                              <img src={Edit} alt="edit" />
                            </span>
                          }
                          {((object.contentDataSubIsApproved === '0') && (object.isSaveDraft === "false") && (typeof window.sessionStorage.getItem("roleName") !== "undefined") && (window.sessionStorage.getItem("roleName") === "Admin")) &&
                            <span
                              className="editIcon lockButton" >
                              <img src={lock} alt="Lock" />
                            </span>
                          }
                          {(object.contentDataSubIsApproved === '1' || object.isSaveDraft === "true") &&
                            <span
                              className="editIcon editButton"
                              onClick={(e) => {
                                this.deleteServicesDetails(object, index);
                              }}
                            >
                              <img src={Delete} alt="delete" />
                            </span>
                          }
                        </div>
                        <div className="adminIconLeft">
                          {/* {window.sessionStorage.getItem('roleName') === "SuperAdmin" && this.state.isApprovedEnable > 0 ?
                            <div className="">
                              <div className="approveButton" onClick={() => this.approveClick()}>Approve</div>
                            </div>
                            : ""} */}
                          {object.isSaveDraft === "true" && object.isRejected === "false" ?
                            <div className="draftSpan"> Draft </div>
                            : ""}
                          {window.sessionStorage.getItem('roleName') === 'SuperAdmin' && object.contentDataSubIsApproved === '0' ?
                            <div className="rejectSection">
                              <div className="rejectButton" onClick={() => this.rejectData(object.contentDataSubId, index)}> Reject </div>
                              <textarea
                                className="rejectComment"
                                placeholder="Enter Reason"
                                id={"servicesRejectReason" + index}
                              ></textarea>
                            </div>
                            : ""}
                          {object.isSaveDraft === "true" && object.isRejected === "true" && window.sessionStorage.getItem('roleName') === "Admin" ?
                            <div className="rejectSection">
                              <div className="rejectButton"> Rejected </div>
                              <div className="rejectCommentText">Reason : {object.rejectComment}</div>
                            </div>
                            : ""}
                        </div>
                      </>
                    )
                    : ""
                  )}
                </div>

                <div className="edit-banner-section">
                  <div className="location_edit_divmain">
                    <div className="location_edit_div">
                      <input type="text" id={"serviceHeading" + index} className="editInput" placeholder="Enter Text" />
                      <Editor
                        editorState={this.state["editorState2" + index]}
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperClassName"
                        editorClassName="editorClassName" 
                        onEditorStateChange={(e) => this.onEditorStateChange(e, "editorState2" + index)}
                        handleBeforeInput={(e) => this.handleBeforeInput(e, "editorState2" + index)}
                        handlePastedText={input => {
                          const inputLength = this.state["editorState2" + index]
                            .getCurrentContent()
                            .getPlainText().length;
                          let remainingLength = 500 - inputLength;
                          if (input.length + inputLength > 500) {
                            const newContent = Modifier.replaceText(
                              this.state["editorState2" + index].getCurrentContent(),
                              this.state["editorState2" + index].getSelection(),
                              input.slice(0, remainingLength)
                            );
                            this.onEditorStateChange(
                              EditorState.push(
                                this.state["editorState2" + index],
                                newContent,
                                "insert-characters"
                              ), "editorState2" + index
                            );
                            return true;
                          } else {
                            return false;
                          }
                        }}
                        toolbar={toolbarTools}
                      />
                    </div>
                  </div>
                  <div className="editPanelButton">
                  {roleName === "Admin" &&
                    <span className="saveButton saveDraft" onClick={(e) => { this.saveServiceDetails("DRAFT", index) }}>Save Draft</span>
                      }
                    <span className="saveButton" id={"submitBanner"} onClick={(e) => { this.saveServiceDetails("Save", index) }}>Submit</span>
                    <span className="cancelButton" onClick={(e) => { this.cancelLocationOption() }}>Cancel</span>
                  </div>
                </div>
              </div>
            ))
            :
            (this.state.isApprovedEnable == 0) && (
            <>
              {/* <div className="service_option">
                <h2 className="service_optionhead">Services Option </h2>
                <ul>
                  <li>Delivery</li>
                  <li>In-store Shopping</li>
                </ul>
              </div> */}
            </>
          )}
          
          {
            (window.sessionStorage.getItem("roleName") === "SuperAdmin" ||
              window.sessionStorage.getItem("roleName") === "Admin") && (
              (window.sessionStorage.getItem('isLogedIn') === "1" && this.props.servicesDetails.length < 3) &&
              <div className="adminIconMain adminIconMainBtm">
                <span
                  className="editIcon addButton"
                  onClick={(e) => {
                    this.addServicesDetails();
                  }}
                >
                  <img src={Add} alt="Add" />
                </span>
              </div>
            )}
          <div className="edit-banner-section">
            <div className="location_edit_divmain">
              <div className="location_edit_div">
                <input type="text" id="serviceHeading" className="editInput" placeholder="Enter Heading" />
                <Editor
                  editorState={this.state["editorState"]}
                  toolbarClassName="toolbarClassName"
                  wrapperClassName="wrapperClassName"
                  editorClassName="editorClassName"
                  onEditorStateChange={(e) => this.onEditorStateChange(e, "editorState")}
                  handleBeforeInput={(e) => this.handleBeforeInput(e, "editorState")}
                  handlePastedText={input => {
                    const inputLength = this.state["editorState"]
                      .getCurrentContent()
                      .getPlainText().length;
                    let remainingLength = 500 - inputLength;
                    if (input.length + inputLength > 500) {
                      const newContent = Modifier.replaceText(
                        this.state["editorState"].getCurrentContent(),
                        this.state["editorState"].getSelection(),
                        input.slice(0, remainingLength)
                      );
                      this.onEditorStateChange(
                        EditorState.push(
                          this.state["editorState"],
                          newContent,
                          "insert-characters"
                        ), "editorState"
                      );
                      return true;
                    } else {
                      return false;
                    }
                  }}
                  toolbar={toolbarTools}
                />
              </div>
            </div>
            <div className="editPanelButton">
            {roleName === "Admin" &&
              <span className="saveButton saveDraft" onClick={(e) => { this.saveServiceDetails("DRAFT") }}>Save Draft</span>
            }
              <span className="saveButton" id={"submitBanner"} onClick={(e) => { this.saveServiceDetails("Save") }}>Submit</span>
              <span className="cancelButton" onClick={(e) => { this.cancelLocationOption() }}>Cancel</span>
            </div>
          </div>
      </div>
    );
  }
}
export default LocalPageServices;
